<div class="dialogHead">

    <h3>List of Containers to Off-Hire</h3>
    <span class="subTitle">Verify the containes before proceeding. Only valid containers will be off-hired.</span>
    <!-- <span class="subText"> -->
    <!--     Click on save button to create a DO with only valid containers. -->
    <!-- </span> -->
</div>

<mat-dialog-content class="testing">
    <div class="setTable">
        <mat-table [dataSource]="dataSource" matSort>
            <ng-container [matColumnDef]="'container_number'">
                <mat-header-cell *matHeaderCellDef>Container Number</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <span>
                        {{data?.container_number}}
                    </span>
                </mat-cell>

            </ng-container>
            <ng-container [matColumnDef]="'size'">
                <mat-header-cell *matHeaderCellDef>Size-Type</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span>
                            {{(data?.size ? data?.size.size : '-') + ' ' + (data?.type ? data?.type.code : '-')}}
                        </span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'drop_off_date'">
                <mat-header-cell *matHeaderCellDef>Drop off date</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <span> {{data?.lifecycle ? (data?.lifecycle.activity_date | date:"dd MMM, yyyy") : '-'}}</span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'drop_off_depot'">
                <mat-header-cell *matHeaderCellDef>Drop off depot</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <span> {{data?.lifecycle ? data?.lifecycle.current_location?.name : '-'}}</span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'return_order'">
                <mat-header-cell *matHeaderCellDef>Return Order</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <span> {{data?.return_detail ? data?.return_detail?.return_reference_no : '-'}}</span>
                </mat-cell>
            </ng-container>
            <!-- <ng-container [matColumnDef]="'supply_request'">
                <mat-header-cell *matHeaderCellDef>Supply Req. No.</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <span> {{data?.supply_request ? data?.supply_request?.request_number : '-'}}</span>
                </mat-cell>
            </ng-container> -->

            <ng-container [matColumnDef]="'use_req_no'">
                <mat-header-cell *matHeaderCellDef>Use Req. No</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <span> {{data?.use_request ? data?.use_request?.request_number : '-'}}</span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'mnr_status'">
                <mat-header-cell *matHeaderCellDef>MNR Status</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <mat-chip *ngIf="data?.mnr_status" [style.background-color]="data?.mnr_status ? data?.mnr_status?.color_code :
                    '#ff000047'" class="tableMatChip">
                        <span>{{data?.mnr_status?.value == 'Mark Available' ? 'Available' :
                            data?.mnr_status?.value}}</span>
                    </mat-chip>
                    <span *ngIf="!data?.mnr_status">-</span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'supplier_name'">
                <mat-header-cell *matHeaderCellDef>Supplier Name</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <span> {{data?.lifecycle?.owner_company ? data?.lifecycle?.owner_company?.legal_name : '-'}}</span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'errors'">
                <mat-header-cell *matHeaderCellDef>Error Messages</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <div *ngIf="data.has_errors" class="depotCollection">
                        <!-- <li *ngFor="let error of data.errors">
                            <span>{{ error }}</span>
                        </li> -->
                        <span>
                            {{data?.errors[0]}}
                        </span>
                        <span class="additionalError" *ngIf="data?.errors.length > 1" [matTooltipShowDelay]="400"
                              [matTooltip]="data?.errors" matTooltipClass="tooltip-list">
                            {{data?.errors?.length > 1 ? "+" + (data?.errors?.length - 1) + " more errors" :
                            data?.errors?.length == 1 ? "+" + (data?.errors?.length - 1) + " more errors" : ''}}
                        </span>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'action'">
                <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 align-items-flex-end ">
                    <div class="enableDelete">
                        <i class="flaticon-delete" matTooltip="Delete Container" (click)="removeContainer(data)"></i>
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns; let index"
                     [style.background-color]="row.has_errors ? '#ff000047' : 'white'"
                     [style.color]="row.has_errors ? 'white' : 'black'" [class.blur]="loading">
            </mat-row>
        </mat-table>
        <div class="loadingData" [class.d-none]="!loading">
            <logzy-gear-loader></logzy-gear-loader>
        </div>
        <!-- <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator> -->
    </div>
</mat-dialog-content>

<app-text-field [label]="'Notes & Remarks'" [isMultiline]="true" [isEditable]="true"
                [(ngModel)]="data.containerOffhireObject.remarks" [errors]="errorObj.remarks"
                fxLayout="column"></app-text-field>

<mat-dialog-actions class="justify-content-between pt-0">
    <button mat-raised-button mat-dialog-close class="Cancel" [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button class="Save" [disabled]="disableSave" (click)="postOffhireContainers()">
        <span *ngIf="!disableSave">
            Save
        </span>
        <div *ngIf="disableSave" class="p03">
            <i class="flaticon-loading spin"></i>
            <span>Confirming...</span>
        </div>
    </button>
</mat-dialog-actions>